import wixWindowFrontend from "wix-window-frontend";
const viewMode = wixWindowFrontend.viewMode;

$w.onReady(function () {
    checkSubscriptionPlan();
});

$widget.onPropsChanged((oldProps, newProps) => {
    handleMultistateBoxDisplay(newProps);
    applyCalenderSettings(newProps);
});

// Function to check the subscription plan and set visibility based on the plan and view mode
async function checkSubscriptionPlan() {
    $w("#loadingBox").changeState('spinnerState');
    // const subscription = await getSubscription();

    // if (subscription.isPremium) {
    //     handleVisibilityOnViewMode(DESIGN_VISIBILITY_FOR_PREMIUM_SITE); // Premium users have full access

    const widgetProps = $widget.props;
    handleInitialProps(widgetProps, viewMode);
    applyCalenderSettings(widgetProps);
    // } else {
    //     if (viewMode === 'Site') {
    //         handleVisibilityOnViewMode(DESIGN_VISIBILITY_FOR_NON_PREMIUM_LIVE_SITE);
    //     } else if (viewMode === 'Editor') {
    //         handleVisibilityOnViewMode(DESIGN_VISIBILITY_FOR_NON_PREMIUM_EDITOR);
    //         handleInitialProps(viewMode);
    //     } else if (viewMode === 'Preview') {
    //         handleVisibilityOnViewMode(DESIGN_VISIBILITY_FOR_NON_PREMIUM_PREVIEW);
    //         handleInitialProps(viewMode);
    //     }
    // }
}

function handleInitialProps(widgetProps, viewMode) {
    const { calenderUrl } = widgetProps;

    if (viewMode === "Editor" ) {
        if (!calenderUrl) {
            $w("#mainMultistateBox").changeState('guideTemplate');
        } else {
            $w("#mainMultistateBox").changeState('calenderTemplate');
            applyCalenderSettings(widgetProps);
        }
        $w("#mainMultistateBox").show();
    } else if (viewMode === "Site" || viewMode === "Preview" ) {
        if (!calenderUrl) {
            $w("#mainMultistateBox").hide();
        } else {
            $w("#mainMultistateBox").changeState('calenderTemplate');
            applyCalenderSettings(widgetProps);
            $w("#mainMultistateBox").show();
        }
    }
    $w("#loadingBox").changeState('contentState');
}

function handleMultistateBoxDisplay(widgetProps) {
    const { calenderUrl } = widgetProps;
    if (!calenderUrl) {
        $w("#mainMultistateBox").changeState('guideTemplate');
    } else {
        $w("#mainMultistateBox").changeState('calenderTemplate');
    }
    $w("#mainMultistateBox").show();
}

function applyCalenderSettings(widgetProps) {
    const { calenderUrl, widgetWidth, widgetHeight,titleName,startSelector,viewSelector,themeColor } = widgetProps;
    const iframeContent = generateCalenderIframeContent({ calenderUrl, widgetWidth, widgetHeight,titleName,startSelector,viewSelector,themeColor });

    if (!iframeContent || !iframeContent.src) {
        console.error("Invalid iframe content generated.");
        return;
    }
    const calendarData = {
        src: iframeContent.src,
        width: iframeContent.width,
        height: iframeContent.height,
        color:iframeContent.color
    };

    if ($w("#calenderIframe")) {
        $w("#calenderIframe").postMessage(JSON.stringify(calendarData));
    } else {
        console.error("Element #calenderIframe not found.");
    }
}

// function generateCalenderIframeContent({ calenderUrl, widgetWidth, widgetHeight, titleName, startSelector, viewSelector }) {
//     if (!calenderUrl) {
//         console.error("Missing Google Calendar URL.");
//         return null;
//     }

 
//     const weekStartMap = {
//         "saturday": 7,
//         "sunday": 1,
//         "monday": 2
//     };


//     const weekStart = weekStartMap[startSelector.toLowerCase()] || 1; 
//     const validViews = { "week": "WEEK", "month": "MONTH", "schedule": "AGENDA" };
//     const viewMode = validViews[viewSelector.toLowerCase()] || "MONTH";
//     const updatedSrc = `${calenderUrl}&wkst=${weekStart}&ctz=UTC&mode=${viewMode}&title=${encodeURIComponent(titleName)}`;

//     return {
//         src: updatedSrc, 
//         width: widgetWidth || "100", 
//         height: widgetHeight || "600" 
//     };
// }

function generateCalenderIframeContent({ calenderUrl, widgetWidth, widgetHeight, titleName, startSelector, viewSelector, themeColor }) {
    if (!calenderUrl) {
        console.error("Missing Google Calendar URL.");
        return null;
    }

    const weekStartMap = {
        "saturday": 7,
        "sunday": 1,
        "monday": 2
    };

    const weekStart = weekStartMap[startSelector?.toLowerCase()] || 1;
    const validViews = { "week": "WEEK", "month": "MONTH", "schedule": "AGENDA" };
    const viewMode = validViews[viewSelector?.toLowerCase()] || "MONTH";

    // Encode color safely for URL
    const colorParam =    themeColor || "#c80b0b";
 

    const updatedSrc = `${calenderUrl}&wkst=${weekStart}&ctz=UTC&mode=${viewMode}&title=${encodeURIComponent(titleName)}${colorParam}`;

    return {
        src: updatedSrc,
        width: widgetWidth || "550",
        height: widgetHeight || "500",
        color: themeColor || "#c80b0b"
    };
}

